import $ from 'jquery';

let min = 200;
let max = 710;
let count = min;
let polygon = 74;

$(window).on("load resize", function (e) {
  if ($(window).outerWidth() > 767) {
    min = 200;
    max = 710;
    polygon = 74;
  } else {
    min = 0;
    max = 400;
    polygon = 90;
  }
})

let increasing = true;
setInterval(function () {
  if (increasing) {
    count++;
    if (count == max) {
      increasing = false;
    }
  } else {
    count--;
    if (count == min) {
      increasing = true;
    }
  }
  $('circle').attr('cx', count);
}, 1);

$(window).on("load scroll", function (e) {
  if ($(".c-block4").length && !$('.c-header').hasClass('is-show')) {
    let persent = $(window).scrollTop() * polygon / $(".c-block4").offset().top;
    if (persent == 0) {
      $(".c-block4__inner").css("clip-path", 'polygon(0 ' + 96.9553 + '%, 100% 0%, 100% ' + 3.04472 + '%, 0% 100%)');
    }
    else {
      let opacity = $(window).scrollTop() / $(".c-block4").offset().top;
      if ($(window).outerWidth() < 768) {
        opacity = $(window).scrollTop() / ($(".c-block4").offset().top - 100);
        persent = $(window).scrollTop() * polygon / ($(".c-block4").offset().top - 100);
      }
      if (persent > polygon) { persent = polygon; } else if (persent < 0) { persent = 0; }
      if (opacity > 1) { opacity = 1; } else if (opacity < 0) { opacity = 0; }
      if (opacity == 1) {
        $(".c-block4").addClass("is-show");
        $(".js-top-scroll").hide();
        $(".c-block4__tit span").show();
        $(".c-block4 [data-aos='animationText1']").addClass("is-active");

      } else {
        $(".c-block4").removeClass("is-show");
        $(".js-top-scroll").show();
        $(".c-block4__tit span").hide();
        $(".c-block4 [data-aos='animationText1']").removeClass("is-active");

      }
      let persent2 = 100 - persent;
      $(".c-block4__inner").css("clip-path", 'polygon(0 ' + persent2 + '%, 100% 0%, 100% ' + persent + '%, 0% 100%)');
      $(".c-block4__bg").css("opacity", 1 - opacity);
    }
  }
})

$(window).on("load", function () {
  $(".p-top1__svg svg").addClass("is-active");
  setTimeout(function () {
    $(".p-top1__svg circle").css("opacity", 1);
  }, 2000);
});